import { render, staticRenderFns } from "./submitOrder.vue?vue&type=template&id=b394c8e6&scoped=true"
import script from "./submitOrder.vue?vue&type=script&lang=js"
export * from "./submitOrder.vue?vue&type=script&lang=js"
import style0 from "./submitOrder.vue?vue&type=style&index=0&id=b394c8e6&prod&lang=scss"
import style1 from "./submitOrder.vue?vue&type=style&index=1&id=b394c8e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b394c8e6",
  null
  
)

export default component.exports